import { ComponentStyleConfig } from "@chakra-ui/react";

const Tabs: ComponentStyleConfig = {
   parts: ["tabs", "tablist", "tab", "tabpanel"],

   baseStyle: {},

   variants: {
      enclosed: {
         tab: {
            border: "1px solid",
            mb: "-1px",
            _selected: {
               color: "beige.300",
               borderColor: "beige.200",
               borderBottomColor: "transparent",
               _focus: {
                  boxShadow: "none",
               },
            },
         },
         tablist: {
            mb: "-1px",
            borderColor: "beige.200",
         },
      },
      line: {
         tab: {
            borderBottom: "2px solid",
            mb: "-1px",
            _selected: {
               color: "beige.300",
               fontWeight: "bold",
               _focus: {
                  boxShadow: "none",
               },
            },
         },
         tablist: {
            mb: "-1px",
            borderColor: "blue.700",
         },
      },
   },
};

export { Tabs };
